var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "500", "retain-focus": false },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "mt-3",
                      attrs: {
                        rounded: "",
                        color: "grey",
                        dark: "",
                        cytag: "retest",
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v("\n      このテストを削除する\n    ")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.confimDialog,
        callback: function ($$v) {
          _vm.confimDialog = $$v
        },
        expression: "confimDialog",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline grey lighten-2" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: { click: _vm.onDelete },
                },
                [_vm._v("\n        削除\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }